export const TOKEN_CONSTANTS = {
  ACCESS: 'accessToken',
  REFRESH: 'refreshToken',
  QUIZ: 'qToken',
  QUIZ_OFFLINE: 'QUIZ_OFFLINE'
};
